<div class="row row-cols-1 row-cols-md-2">
    <div class="col">
        <div class="card mb-0">
            <div class="card-body">
                <div class="h5">
                    차량선택
                </div>
                <div class="table-responsive">
                    <table class="table table-sm table-hover align-items-center mb-0">
                        <thead class="">
                            <th>
                                <div class="form-check pl-0 text-center">
                                    <input type="checkbox" class="form-check-input position-relative ml-0"
                                        [(ngModel)]="isCarAll"
                                        (ngModelChange)="changeCarAll($event)">
                                </div>
                            </th>
                            <th>
                                차량번호
                            </th>
                            <th>
                                단말번호
                            </th>
                        </thead>
                        <tbody class="">
                            <ng-container *ngIf="listCar">
                                <tr *ngFor="let item of listCar;">
                                    <td>
                                        <div class="form-check pl-0 text-center">
                                            <input type="checkbox" class="form-check-input position-relative ml-0"
                                                [(ngModel)]="item.checked">
                                        </div>
                                    </td>
                                    <td>
                                        {{item.dtgCarNo}}
                                    </td>
                                    <td>
                                        {{item.dtgUnitId}}
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="col">
        <div class="card mb-0">
            <div class="card-body">
                <div class="h5">
                    기간선택
                </div>
                <div class="input-group">
                    <input type="hidden" class="form-control"
                        ngbDatepicker
                        #datepicker="ngbDatepicker"
                        [autoClose]="false"
                        [displayMonths]="2"
                        [dayTemplate]="t"
                        outsideDays="hidden"
                        firstDayOfWeek="7"
                        [footerTemplate]="footerTemplate"
                        [startDate]="displayDateFrom"
                        [minDate]="minDate"
                        [maxDate]="maxDate"
                        (dateSelect)="onDateSelection($event)">
                    <ng-template #t let-date let-focused="focused">
                        <span class="custom-day"
                            [class.focused]="focused"
                            [class.range]="isRange(date)"
                            [class.faded]="isHovered(date) || isInside(date)"
                            [class.sunday]="isSunday(date)"
                            [class.saturday]="isSaturday(date)"
                            (mouseenter)="hoveredDate = date"
                            (mouseleave)="hoveredDate = null">
                            {{ date.day }}
                        </span>
                    </ng-template>
                    <ng-template #footerTemplate>
                        <hr class="my-0">
                        <div class="d-flex bg-light p-2 align-items-center">
                            <div>
                                <input type="text"
                                    class="form-control form-control-sm"
                                    placeholder="yyyy-mm-dd"
                                    [(ngModel)]="searchInfo.dtgRegDtFrom">
                            </div>
                            <div class="mx-1">-</div>
                            <div>
                                <input type="text"
                                    class="form-control form-control-sm"
                                    placeholder="yyyy-mm-dd"
                                    [(ngModel)]="searchInfo.dtgRegDtTo">
                            </div>
                            <div class="flex-grow-1 text-right">
                                <button type="button"
                                    class="btn btn-sm btn-success"
                                    (click)="selectToday()">오늘</button>
                                <button type="button"
                                    class="btn btn-sm btn-outline-info ml-2"
                                    (click)="clickOk(datepicker)">확인</button>
                            </div>
                        </div>
                    </ng-template>
                </div>
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control form-control-sm" readonly
                        [(ngModel)]="searchInfo.dtgRegDtFrom">
                    <div class="input-group-append">
                        <span class="input-group-text" role="button"
                            (click)="clickOpen(datepicker)">
                            부터
                        </span>
                    </div>
                </div>
                <div class="input-group input-group-sm mt-3">
                    <input type="text" class="form-control form-control-sm" readonly
                        [(ngModel)]="searchInfo.dtgRegDtTo">
                    <div class="input-group-append">
                        <span class="input-group-text" role="button"
                            (click)="clickOpen(datepicker)">
                            까지
                        </span>
                    </div>
                </div>

                <div class="h5 mt-5">
                    파일 비밀번호
                </div>
                <input type="text" class="form-control form-control-sm" placeholder="압축파일의 비밀번호"
                    [(ngModel)]="searchInfo.filePw">

                <div class="h5 mt-5">
                    이메일
                </div>
                <input type="email" class="form-control form-control-sm" placeholder="e-mail"
                    [(ngModel)]="searchInfo.email">
                <div class="mt-3 text-right">
                    <button type="button" class="btn btn-sm btn-outline-secondary"
                        (click)="clickDownloadRequest()">
                        다운로드 요청
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #modalWarn let-modalObjWarn>
    <div class="modal-header py-2 bg-dark text-light">
        <h5 class="modal-title">
            제출파일 다운로드
        </h5>
    </div>
    <div class="modal-body">
        <div [innerHtml]="reqErrMsg"></div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-success btn-sm"
            (click)="modalObjWarn.close('cancel')">
            <span class="">
                확인
            </span>
        </button>
    </div>
</ng-template>